import { PropsWithChildren } from 'react';

// Basic wrapper component for bold text
export const Bold = ({ children }: PropsWithChildren) => (
  <span className='font-bold'>{children}</span>
);
